import { useQuery } from "@tanstack/react-query";
import { downloadCampaignReport } from "../../service/query/auth";

export const useDownloadCampaignReport = ({ payload}) => {
  const campaignReport= useQuery({
    queryKey: ['campaignReport', payload],
    queryFn: () => downloadCampaignReport({ ...payload }),
    enabled: !!payload,
    keepPreviousData: true,
  },
  
  

);
  return {data:campaignReport?.data?.data,  ...campaignReport,}
};